// extracted by mini-css-extract-plugin
export default {"checkboxSquare":"checkboxSquare_checkboxSquare__D+mwS","indicatorSquare":"checkboxSquare_indicatorSquare__6AQf0","label":"checkboxSquare_label__cNkDT"};